import React from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as AddIcon } from "../../../../../../public/icons/add-icon.svg";
import NewPlaylistModal from "../../../../shared/NewPlaylistModal";
import {
  indexPlaylists,
  addMediumToPlaylist,
} from "../../../../../../api/playlists";
import { log_error } from "../../../../../../api";
import { Spinner } from "react-bootstrap";

export default class AddTrackToPlayistModal extends React.Component {
  state = { show: false, playlists: [], error: null, loading: true };
  handleClickModal = e =>
    this.hocWrapper.current &&
    this.hocWrapper.current.contains(e.target) &&
    this.handleShow();
  componentDidMount() {
    document.body.addEventListener("click", this.handleClickModal);
    this.getPlaylists();
  }

  getPlaylists = async () => {
    if (!this.props.user) return;
    let {
      data: { playlists },
    } = await indexPlaylists(
      {
        filter: {
          user_id: this.props.user.id,
          is_rss: false,
        },
      },
      this.props.medium.id
    );
    this.setState({ playlists, loading: false });
  };

  componentWillUnmount = () =>
    document.body.removeEventListener("click", this.handleClickModal);
  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });
  hocWrapper = React.createRef();

  addTrack = async id => {
    this.setState({ error: null });
    try {
      await addMediumToPlaylist(id, {
        playlists_medium: { medium_id: this.props.medium.id },
      });
      this.setState({
        error: {
          type: "success",
          body: "The track was added successfully!",
        },
      });
    } catch (error) {
      this.setState({
        error: {
          type: "danger",
          body: log_error(error)[0].message,
        },
      });
    }
  };

  render() {
    if (!this.props.user) return null;
    return (
      <React.Fragment>
        <div
          ref={this.hocWrapper}
          className={"hor_click " + this.props.className}
        >
          {this.props.children}
        </div>
        <Modal size="sm" show={this.state.show} onHide={this.handleClose}>
          <Modal.Body className="text-center p-4">
            {this.state.loading ? (
              <Spinner animation="border" role="status" />
            ) : (
              <div className="playlists-buttons d-flex flex-column">
                {this.state.playlists.map(playlist => (
                  <span
                    onClick={() => this.addTrack(playlist.id)}
                    className="border-light border-bottom"
                  >
                    <strong>{playlist.title}</strong>
                  </span>
                ))}
                <NewPlaylistModal medium={this.props.medium}>
                  <AddIcon className="mt-3" />
                </NewPlaylistModal>
              </div>
            )}
            {this.state.error && (
              <div
                className={
                  "text-center mt-3 alert alert-" + this.state.error.type
                }
              >
                {this.state.error.body}
              </div>
            )}
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
